<div class="wrapper blue" [ngClass]="{'blue': defaultBackgoundColor(), 'expanded': expanded()}" >
    <div class="column-50">
        @for (row of left(); track $index; let lastrow = $last) {
            <div class="row blue" [ngClass]="{'expanded': expanded(), 'noborder borderonmobile': lastrow}">
                <div class="name">{{ row.name }}</div>
                <div class="value">{{ row.value }}</div>
            </div>
        }
    </div>
    <div class="column-50">
        @for (row of right(); track $index; let lastrow = $last) {
            <div class="row blue" [ngClass]="{'expanded': expanded(), 'noborder': lastrow}">
                <div class="name">{{ row.name }}</div>
                @if (isNumber(row.value)) {
                    <div class="value">{{ row.value | areaconverter }}</div>
                } @else {
                    <div class="value">{{ row.value }}</div>
                }
            </div>
        }
    </div>
</div>